import type { LoadedVault, } from "@bracket/types";

export const isMorphoDisabledVault = ( vault: LoadedVault, ): boolean => {
	return !vault.morpho_url || vault.morpho_url.toUpperCase().includes("DISABLED");
}
